<template>
  <div>
    <headEnterprise></headEnterprise>
    <banner :banner="banner"></banner>
	<enterTitle></enterTitle>
    <div class="w80 mb-30 mt-30">
      <el-container>
        <el-aside width="330px">
          <base-info @onCollection="goCollection()" :shareObj="detail"></base-info>
          <!-- <div class="saide_middle">
            <div class="saide_mater">
              <p>产品分类</p>
            </div>
            <div class="saide_tree">
              <el-tree :data="data" show-checkbox node-key="id"> </el-tree>
            </div>
          </div> -->
        </el-aside>
        <el-main>
          <contTitle :obj="obj" :contTitle="contTitle"></contTitle>
          <div class="mt-30">
            <div class="mt-10">
             <!-- <div class="corporate_top fdc">
                <img src="../../assets/images/photo.png" />
                <div>
                  <p>浙江某公司电镀废水处理工程【项目走访】</p>
                  <p>
                    将近8月底，我们接到了来自浙江的一家公司邀请，希望跟我们谈一谈关于电镀废水处理的问题。随着我国工业化水平的不断提高,我国国内的化工厂
                    ...
                  </p>
                  <p>
                    <span>详情 ></span>
                  </p>
                </div>
              </div> -->

              <div class="corporate_middle">
                <div
                  class="middle_cont"
                  v-for="(item, index) in list"
                  :key="index"
                  @click="onDeatil(item)"
                >
                  <div class="middle_cont_left">
                    <img :src="item.cover" alt="" />
                  </div>
                  <p class="mt-10 title_far">{{ item.title }}</p>
                  <div class="middle_text fdc">
                    <p>{{ item.createTime.substring(0, 10) }}</p>
                    <p>
                      <span>浏览数 : </span><span>{{ item.readCount }}</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <!--分页-->
            <Pagination
              v-show="total > 0"
              :total="total"
              :page.sync="listQuery.curPage"
              :limit.sync="listQuery.limit"
              @pageChange="pageChange"
            ></Pagination>

            <div style="margin-top:20%;">
                <notList :notCode="notCode"></notList>
            </div>
          </div>
        </el-main>
      </el-container>
    </div>
    <footCom></footCom>
  </div>
</template>
<script>

import { delIndustryinfo, industryinfoList } from "@/api/company";
import footCom from "../../common/footCom";
import headEnterprise from "../../common/headEnterprise";
import banner from "../../common/banner";
import contTitle from "../../common/contTitle";
import baseInfo from "@/components/companyintroCard";
import Pagination from "../../components/Pagination";
import notList from "../../common/notList"
import enterTitle from "../../common/enterTitle"
import{addCollection} from "@/api/coment"
export default {
  components: {
    footCom,
    headEnterprise,
    banner,
    contTitle,
    baseInfo,
    Pagination,
    notList,
	enterTitle
  },
  data() {
    return {
      contTitle: "公司资讯",
      banner: {
        title: "公司资讯",
        isShow: false,
        isColor: false,
        type:'',
        usertype:'',
        companytype:'',
        bannerUrl:"",
      },
      obj:{},
      list: [],
      listQuery: {
        curPage: 1,
        limit: 6,
      },
      total: 0, //总条数
      readId: "",
      detail:"",
      checkList: [],
	    notCode:false
    };
  },
  created(){
     this.$store.dispatch("company/getBaseInfo");

  },
  computed: {
    userInfo() {
      return this.$store.getters.companyInfo;
    },
  },
  watch: {
    userInfo: {
      handler: function (val, oldVal) {
        if (val.userId) {
          this.banner.bannerUrl = val.banner;
          this.getList();
        }
      },
      immediate: true,
    },
  },
  methods: {
    //添加资讯
    addInformation() {
      this.$router.push("/corporate_owned");
    },
    onDeatil(item){
      this.$router.push({
        path:'/info_detail',
        query:{
          id:item.id
        }
      })
    },
    //获取列表
    getList() {
      industryinfoList({ ...this.listQuery,releaseType:2, userid: this.userInfo.userId })
        .then((res) => {
			if(res.code == 0){
			   this.list = res.page.list;
			   this.total = res.page.totalCount;
			   this.list.length == 0 ? this.notCode = true : this.notCode = false;
			}
        }).catch((err) => {});
    },
    //收藏
    goCollection(){
      let params ={
        goodsId: this.id,
        goodsType: 7
      }
      addCollection(params).then((res)=>{
        if(res.code == 0){
          this.$message({
            message: '收藏成功！',
            type: 'success'
          });
        }
      }).catch((err)=>{})
    },
    //分页
    pageChange(item) {
      this.listQuery["curPage"] = item.page;
      this.listQuery["limit"] = item.limit;
      this.getList();
    },
  },
};
</script>
<style scoped>
.el-aside {
  height: 930px;
}
.mt-30 {
  margin-top: 30px;
}
.mt-15 {
  margin-top: 15px;
}
.corporate_top {
  display: none;
}
.corporate_top img {
  width: 60%;
  height: 336px;
}
.corporate_top div {
  width: 40%;
  height: 336px;
  background: #02b854;
  padding: 40px 30px;
  text-align: left;
}
.corporate_top div p:first-child {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #fefefe;
  margin-top: 25px;
}
.corporate_top div p:nth-child(2) {
  margin-top: 15px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #fefefe;
  line-height: 24px;
}
.corporate_top div p:last-child {
  margin-top: 30px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #fefefe;
}
.corporate_middle {
  margin-top: 15px;
  display: flex;
  justify-content: space-between;
  flex-flow: wrap;
}
.corporate_middle::after{
  content: '';
  width: 31%;
}
.middle_cont {
  width: 31%;
  text-align: left;
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  border: 1px solid #DEDEDE;
  transition: all 0.5s;
}
.middle_cont:hover{
  cursor: pointer;
  box-shadow: 0 0 20px #ddd;
}
.middle_cont_left{
  overflow: hidden;
  width: 100%;
  height: 162px;
}
.middle_cont_left img {
  width: 100%;
  height: 100%;
  transition: all 0.6s;
}
.middle_cont_left img:hover{
  cursor: pointer;
  transform: scale(1.2);
}
.middle_cont p:nth-child(1) {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #343434;
}
.middle_text {
  margin-top: 15px;
  padding: 0px 10px;
  margin-bottom: 10px;
}
.title_far{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 0px 10px;
}
.middle_text p:nth-child(1) {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #9a9a9a;
}
.middle_text p:nth-child(2) {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #9a9a9a;
}

.el-pagination {
  margin-top: 40px;
}
.el-aside {
  background: white;
  height: auto;
  /* border: 1px solid red; */
}
.saide_mater {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 20px;
  border-bottom: 1px dashed #e1e1e1;
}
.saide_mater p {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
}
.saide_mater span {
  cursor: pointer;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
}

.el-tree {
  background: #f8f8f8;
}

</style>



// WEBPACK FOOTER //
// src/view/corporate/corporate_list_all.vue